<template>
    <b-modal v-model="show" title="ПАРАМЕТЕР" :no-close-on-esc="true" :no-close-on-backdrop="true">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label> Обеъкт тури <span class="red">*</span></label>
                        <select class="form-control"
                                v-model="dictionaryData.data.category"
                                :class="{invalid: $v.dictionaryData.data.category.$error}"
                        >
                            <option value="GREEN_HOUSE">Иссиқхона</option>
                            <option value="LAKE">Кўл</option>
                            <option value="GARDEN">Боғлар</option>
                        </select>
                    </div>
                    <div class="section-header">
                        <h4>1 гекторгача</h4>
                    </div>
                    <div class="form-group">
                        <label>1м2 дан гача <span class="red">*</span></label>
                        <numeric-input v-model="dictionaryData.data.maxArea"
                                       :precision="2"
                                       :class="{invalid: $v.dictionaryData.data.maxArea.$error}"
                        ></numeric-input>
                    </div>
                    <div class="form-group">
                        <label>Шартнома сўммаси</label>
                        <numeric-input v-model="dictionaryData.data.minContractAmount"
                                       :precision="2"
                                       :class="{invalid: $v.dictionaryData.data.minContractAmount.$error}"
                        ></numeric-input>
                    </div>
                    <div class="section-header">
                        <h4>1 гектордан ошганда</h4>
                    </div>
                    <div class="form-group">
                        <label>1м2 <span class="red">*</span></label>
                        <numeric-input v-model="dictionaryData.data.perArea"
                                       :precision="2"
                                       :class="{invalid: $v.dictionaryData.data.perArea.$error}"
                        ></numeric-input>
                    </div>
                    <div class="form-group">
                        <label>1 м2 учун сўмма <span class="red">*</span></label>
                        <numeric-input v-model="dictionaryData.data.perAreaAmount"
                                       :precision="2"
                                       :class="{invalid: $v.dictionaryData.data.perAreaAmount.$error}"
                        ></numeric-input>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn add-btn float-right" v-if="hasPermission('SETTINGS_BUILDING_OTHER_CONTRACT_AMOUNT_ADD')" @click="save">
                Сақлаш
            </button>
            <button class="all-btn delete-btn float-right mr-2" @click="close">
                Бекор қилиш
            </button>
        </div>
    </b-modal>
</template>

<script>
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import {required, minValue} from 'vuelidate/lib/validators';

    export default {
        name: "LCElementContractAmountEditModal",
        components: {
            'b-modal': bModal
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                processing: false,
                dictionaryData: this.initData()
            }
        },
        validations() {
            return {
                dictionaryData: {
                    data: {
                        category: {
                            required: required
                        },
                        minContractAmount: {
                            required: required,
                            minValue: minValue(0.01)
                        },
                        maxArea: {
                            required: required,
                            minValue: minValue(0.01)
                        },
                        perArea: {
                            required: required,
                            minValue: minValue(0.01)
                        },
                        perAreaAmount: {
                            required: required,
                            minValue: minValue(0.01)
                        }
                    }
                }
            }
        },
        methods: {
            initData() {
                return {
                    id: null,
                    dictionaryType: 'REAL_ESTATE_OTHER_CONTRACT_AMOUNT',
                    data: {
                        category: null,
                        minContractAmount: 0,
                        minArea: 1,
                        maxArea: 0,
                        perAreaAmount: 0,
                        perArea: 0
                    }
                }
            },
            save() {

                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }

                const vm = this;
                this.processing = true;
                this.$http.post('dictionary/save',this.dictionaryData)
                    .then(res => {
                        const response = res.data;
                        if (response.status === 'SUCCESS') {
                            vm.show = false;
                            this.$emit('change')
                        }
                        vm.processing = false;
                    },err => {
                        vm.processing = false;
                        console.log(err);
                    });
            },
            close() {
               this.show = false
            }
        },
        created() {
            this.$eventBus.$on('showLCElementContractAmountModal', () => {
                this.dictionaryData = this.initData();
                this.show = true;
            })
        }
    }
</script>

<style scoped>

</style>